module.exports = __webpack_public_path__ + "img/promotoresCara.509aea3a.svg";